import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import { getSunburstTotal } from "../Utilitie";

const SunburstChart = ({
  data,
  length,
  from,
  fYear,
  chartHeight,
  outerLayer,
  showPercent,
}) => {
  const [chartTotalValue, setChartTotalValue] = useState(length || 0);
  const [showOuterLabel, setShowOuterLabel] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const [totalSecondValue, setTotalSecondValue] = useState(0);
  const [chartData, setChartData] = useState(data || []);
  const [history, setHistory] = useState([]);

  const calculateTotalValue = (nodes) => {
    if (!nodes || !Array.isArray(nodes)) return 0;
    return nodes.reduce((total, node) => {
      const nodeValue = node.value || 0;
      const childrenValue = node.children
        ? calculateTotalValue(node.children)
        : 0;
      return total + nodeValue + childrenValue;
    }, 0);
  };

  useEffect(() => {
    setChartData(data || []);
    let totalValue = calculateTotalValue(data);

    setTotalValue(totalValue);
  }, [length]);

  useEffect(() => {
    setChartData(data || []);
    let totalValue = calculateTotalValue(data);

    setTotalValue(totalValue);
  }, [fYear]);

  useEffect(() => {
    setTotalSecondValue(chartData[0].value);
  }, [chartData]);

  useEffect(() => {
    if (chartData?.length > 0) {
      setChartTotalValue(getSunburstTotal(chartData).toFixed(0));
    } else {
      setChartTotalValue(length || 0);
    }
  }, [chartData, length]);
  const onChartClick = (params) => {
    setShowOuterLabel(true);
    // setTotalSecondValue(params.value);

    setHistory((prev) => [...prev, chartData]);
    setChartData([params.data]);
  };

  const handleGoBack = () => {
    // setTotalSecondValue(params.value);

    setShowOuterLabel(false);
    if (history.length > 0) {
      const previousData = history[history.length - 1];
      setChartData(previousData);
      setHistory((prev) => prev.slice(0, -1));
    }
  };
  const option = {
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        const name = params.name || "Unknown";
        const value = params.data?.value || 0;
        const text = params.data?.text || "";
        if (from === "WAGON") {
          return `<div class="tooltip-box"><b>${name}:</b> ${value}  Wagon
          </div>`;
        }
        if (from === "CH_WEIGHT") {
          return `<div class="tooltip-box"><b>${name}:</b> ${(
            value / 1000000
          ).toFixed(2)}  MT
          </div>`;
        }
        if (from === "lost trains") {
          return `<div class="tooltip-box"><b>${name}:</b> ${
            text || `${value} Trains`
          }</div>`;
        }
        return `<div class="tooltip-box"><b>${name}:</b> ${value} items</div>`;
      },
      extraCssText:
        "width: 250px; white-space: normal; text-align: center; padding: 8px; font-size: 12px; border-radius: 8px; background-color: rgba(0, 0, 0, 0.7); color: #fff;",
      show: true,
    },
    series: [
      {
        type: "sunburst",
        data: chartData,
        radius: [0, "90%"],
        // label: {
        //   show: true,
        //   color: "black",
        //   rotate: "tangential",
        //   position: "inside",
        //   fontSize: 10,
        // },

        label: {
          show: true,
          color: "black",
          rotate: "tangential",
          position: "inside",
          fontSize: 10,
          formatter: (params) => {
            const name = params.name || "";
            const value = params.value || 0;

            const percent = ((value / chartTotalValue) * 100).toFixed(1);
            const isOuterMostLayer =
              params.treePathInfo.length ===
              params.treePathInfo[params.treePathInfo.length - 1].depth + 1;

            if (isOuterMostLayer) {
              // For outermost layer, show only name
              return `${name}`;
            }
            // For inner layers, show name + percent (unless 'lost trains')
            return `${name} ${showPercent ? `| ${percent}%` : ""}`;
          },
        },
        levels: [
          {
            r0: "0%",
            r: "15%",
            label: { position: "inside", rotate: "radial", fontSize: 14 },
          },
          {
            r0: "15%",
            r: "50%",
            label: {
              position: "inside",
              rotate: "radial",
              fontSize: 9,
              position: outerLayer === 2 && "outside",
            },
          },
          {
            r0: "50%",
            r: "65%",
            label: {
              fontSize: 10,
              position: outerLayer === 3 && "outside",
              rotate: "radial",
            },
          },
          {
            r0: "65%",
            r: "75%",
            label: { fontSize: 10, position: outerLayer === 4 && "outside" },
          },
          {
            r0: "75%",
            r: "80%",
            label: {
              show: from === "lost trains" ? true : showOuterLabel,
              position: "outside",
              rotate: "radial",
              color: "black",
              fontSize: 9,
            },
          },
        ],
        itemStyle: { borderWidth: 2 },
        nodeClick: "zoomToNode", // Enable zoom-in animation
        animation: true,
        animationDuration: 1000, // Longer duration for smoother animation
        animationEasing: "cubicOut",
        animationThreshold: 1000, // Ensure animation for complex charts
      },
    ],
  };

  const onEvents = {
    click: onChartClick,
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <div style={{ minHeight: chartHeight || "420px", width: "100%" }}>
        {chartData?.length > 0 ? (
          <div className="position-relative">
            <ReactECharts
              option={option}
              onEvents={onEvents}
              notMerge={true} // Preserve chart state
              style={{ height: chartHeight || "420px", width: "100%" }}
            />
            <div className="position-absolute top-50 start-50 translate-middle">
              <div className="d-flex justify-content-center align-items-center">
                <button
                  className="btn btn-outline-danger d-flex flex-column justify-content-center align-items-center text-center"
                  onClick={handleGoBack}
                  style={{
                    borderRadius: "50%",
                    height: "50px",
                    width: "50px",
                    padding: 0,
                  }}
                >
                  {from === "lost trains" ? (
                    <b>{chartTotalValue}</b>
                  ) : from === "Crew Hq Rest" ? (
                    <b>{chartTotalValue}</b>
                  ) : totalSecondValue ? (
                    <>
                      <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                        {from === "WAGON" ? totalSecondValue : null}
                        {from === "CH_WEIGHT"
                          ? (totalSecondValue / 1000000).toFixed(2)
                          : null}
                      </span>
                      <hr className="m-0 p-0 w-75" />
                      <span style={{ fontWeight: "bold", fontSize: "8px" }}>
                        {from === "WAGON" ? "WAGON" : null}
                        {from === "CH_WEIGHT" ? "MT" : null}
                      </span>
                    </>
                  ) : (
                    <>
                      <span style={{ fontWeight: "bold", fontSize: "12px" }}>
                        {from === "WAGON" ? totalValue : null}
                        {from === "CH_WEIGHT"
                          ? (totalValue / 1000000).toFixed(2)
                          : null}
                        {}
                      </span>
                      <hr className="m-0 p-0 w-75" />
                      <span style={{ fontWeight: "bold", fontSize: "8px" }}>
                        {from === "WAGON" ? "WAGON" : null}
                        {from === "CH_WEIGHT" ? "MT" : null}
                      </span>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <p>No Data</p>
        )}
      </div>
    </div>
  );
};

export default SunburstChart;
